module.exports = __webpack_public_path__ + "static/media/toplook-image.7b9af8ad.png";